"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingCriticalInfoToJSON = exports.MissingCriticalInfoFromJSONTyped = exports.MissingCriticalInfoFromJSON = exports.MissingCriticalInfo = void 0;
/**
 * the info required before attempting to meet the policy
 * @export
 */
exports.MissingCriticalInfo = {
    PatientName: 'Patient name',
    Icds: 'ICDs',
    InsuranceMemberId: 'Insurance member ID',
    InsuranceSubscriberName: 'Insurance subscriber name',
    ProviderName: 'Provider name',
    ProviderNpi: 'Provider NPI'
};
function MissingCriticalInfoFromJSON(json) {
    return MissingCriticalInfoFromJSONTyped(json, false);
}
exports.MissingCriticalInfoFromJSON = MissingCriticalInfoFromJSON;
function MissingCriticalInfoFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MissingCriticalInfoFromJSONTyped = MissingCriticalInfoFromJSONTyped;
function MissingCriticalInfoToJSON(value) {
    return value;
}
exports.MissingCriticalInfoToJSON = MissingCriticalInfoToJSON;
